import {
  FiUsers,
  FiShoppingCart,
  FiSettings,
  FiGift,
  FiUserCheck,
  FiLogOut,
  FiChevronDown,
  FiBox,
  FiActivity,
  FiDollarSign,
  FiCode,
  FiFlag,
  FiHelpCircle,
  FiCheckCircle,

} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { TbMoneybag } from "react-icons/tb";
import { useAuth } from "../../context/AuthContext";
import { MdOutlineStackedBarChart } from "react-icons/md";

const menu = [
  { label: "Dashboard", icon: FiBox, to: "/" },
  { label: "Analytics", icon: MdOutlineStackedBarChart, to: "/analytics" },
  { label: "Members", icon: FiUsers, to: "/users" },
  { label: "Bonus & Penalty", icon: FiGift, to: "/bonus-and-panelty" },
  { label: "Bonus History", icon: FiActivity, to: "/bonus-and-panelty-history" },
  { label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" },
  { label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" },
  { label: "Gift Codes", icon: FiGift, to: "/gift-codes" },
  {
    label: "Support",
    icon: FiHelpCircle,
    children: [
      { label: "Pending Issues", icon: FiHelpCircle, to: "/pending-issues" },
      { label: "Resolved Issues", icon: FiCheckCircle, to: "/resolved-issues" },
    ],
  },
  { label: "API Management", icon: FiCode, to: "/api-management" },
  { label: "Milestones", icon: FiFlag, to: "/milestones" },
  {
    label: "Settings",
    icon: FiSettings,
    children: [
      { label: "Deposit Bonus", icon: FiDollarSign, to: "/settings/deposit/bonus" },
      { label: "General Settings", icon: FiSettings, to: "/settings/general" },
    ],
  },
  { label: "Admin", icon: FiUserCheck, to: "/admin" },
];

/* ─── color tokens ─── */
const GREEN = "#1C8C5B";        /* active border / icon / text */
const GREEN_BG = "#F0FAF5";     /* active background */
const TEXT_PRIMARY = "#111111"; /* nav label */
const TEXT_MUTED = "#6D7588";   /* icon / subtitle */
const BORDER = "#E8EBF4";       /* dividers */
const BG = "hsl(228deg 38.46% 97.45%)";           /* sidebar bg */

const Sidebar = ({ isOpen, onClose }) => {
  const [openGroups, setOpenGroups] = useState({});
  const { user, logout } = useAuth();

  const toggleGroup = (label) =>
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-20 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed z-30 inset-y-0 left-0 w-72
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0
          flex flex-col
        `}
        style={{
          background: BG,
          borderRight: `1px solid ${BORDER}`,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {/* ── Logo ── */}
        <div
          style={{
            padding: "20px 20px 16px",
            // borderBottom: `1px solid ${BORDER}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {/* Green rounded icon — matches the reference */}
            <div
              style={{
                width: 42,
                height: 42,
                borderRadius: 12,
                background: "#1C2011",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 2px 8px rgba(28,140,91,0.25)",
              }}
            >
              {/* Circle-inside-square icon like reference */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="8"
                  stroke="#fff"
                  strokeWidth="2"
                  fill="none"
                />
                <circle cx="12" cy="12" r="3" fill="#fff" />
              </svg>
            </div>

            <div>
              <p
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#111111",
                  margin: 0,
                  lineHeight: 1.25,
                }}
              >
                Demo.zenavoigaming
              </p>
              <p
                style={{
                  fontWeight: 400,
                  fontSize: 11,
                  color: TEXT_MUTED,
                  margin: 0,
                  marginTop: 1,
                }}
              >
                Admin Portal
              </p>
            </div>
          </div>
        </div>

        {/* ── Navigation ── */}
        <nav
          className="sidebar-scroll"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "10px 12px",
          }}
        >
          {menu.map((item) => {
            const Icon = item.icon;
            const hasChildren = !!item.children?.length;
            const isGroupOpen = openGroups[item.label];

            if (!hasChildren) {
              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={onClose}
                  style={({ isActive }) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "10px 14px",
                    borderRadius: 10,
                    marginBottom: 3,
                    textDecoration: "none",
                    fontSize: 14,
                    fontWeight: isActive ? 600 : 500,
                    color: isActive ? GREEN : TEXT_PRIMARY,
                    background: isActive ? GREEN_BG : "transparent",
                    border: isActive
                      ? `1.5px solid ${GREEN}`
                      : "1.5px solid transparent",
                    transition: "all 0.15s ease",
                  })}
                  className="sb-link"
                >
                  {({ isActive }) => (
                    <>
                      <Icon
                        style={{
                          fontSize: 18,
                          color: isActive ? GREEN : TEXT_MUTED,
                          flexShrink: 0,
                        }}
                      />
                      <span>{item.label}</span>
                    </>
                  )}
                </NavLink>
              );
            }

            /* ── Group ── */
            return (
              <div key={item.label} style={{ marginBottom: 3 }}>
                <button
                  onClick={() => toggleGroup(item.label)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 10,
                    border: "1.5px solid transparent",
                    background: isGroupOpen ? "#F4F6FC" : "transparent",
                    color: TEXT_PRIMARY,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: "pointer",
                    textAlign: "left",
                    transition: "all 0.15s ease",
                  }}
                  className="sb-group"
                >
                  <Icon
                    style={{ fontSize: 18, color: TEXT_MUTED, flexShrink: 0 }}
                  />
                  <span style={{ flex: 1 }}>{item.label}</span>
                  <FiChevronDown
                    style={{
                      fontSize: 14,
                      color: TEXT_MUTED,
                      transform: isGroupOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </button>

                {isGroupOpen && (
                  <div
                    style={{
                      marginLeft: 18,
                      paddingLeft: 12,
                      borderLeft: `2px solid ${BORDER}`,
                      marginTop: 2,
                      marginBottom: 4,
                    }}
                  >
                    {item.children.map((child) => {
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          onClick={onClose}
                          style={({ isActive }) => ({
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "8px 12px",
                            borderRadius: 8,
                            marginBottom: 2,
                            textDecoration: "none",
                            fontSize: 13,
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? GREEN : TEXT_MUTED,
                            background: isActive ? GREEN_BG : "transparent",
                            transition: "all 0.15s ease",
                          })}
                          className="sb-link"
                        >
                          {({ isActive }) => (
                            <>
                              {ChildIcon && (
                                <ChildIcon
                                  style={{
                                    fontSize: 14,
                                    color: isActive ? GREEN : TEXT_MUTED,
                                  }}
                                />
                              )}
                              <span>{child.label}</span>
                            </>
                          )}
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        {/* ── NO bottom footer — matches reference image ── */}
      </aside>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .sidebar-scroll::-webkit-scrollbar { width: 4px; }
        .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
        .sidebar-scroll::-webkit-scrollbar-thumb {
          background: #E8EBF4;
          border-radius: 8px;
        }
        .sidebar-scroll::-webkit-scrollbar-thumb:hover { background: #6D7588; }

        .sb-link:hover {
          background: #F4F6FC !important;
          color: #111111 !important;
        }
        .sb-group:hover {
          background: #F4F6FC !important;
        }
      `}</style>
    </>
  );
};

export default Sidebar;